import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Row from 'containers/Manage-Admin/email-templates/Row';
import {
  Table,
  ResultsHeaderRow,
  ResultsHeader,
} from 'components/styled-components';
import { fetchEmailTemplates } from 'actions/email';
import shortid from 'shortid';
import Pagination from 'components/pagination';

const EmailTemplatesBase = ({ fetchEmailTemplates, templates }) => {
  const [perPage, setPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(0);
  const [emailPage, setEmailPage] = useState([]);

  useEffect(() => {
    setEmailPage(getEmailPage());
  }, [templates, currentPage, perPage]);

  useEffect(() => {
    fetchEmailTemplates();
  }, []);

  const getEmailPage = () => {
    return templates.slice(currentPage * perPage, (currentPage + 1) * perPage);
  };

  const handlePageClick = page => {
    setCurrentPage(page);
    setEmailPage(getEmailPage);
  };

  const handlePerPageChange = page => {
    setPerPage(page.value);
    setCurrentPage(0);
    setEmailPage(getEmailPage);
  };

  return (
    <>
      <Table>
        <tbody>
          <ResultsHeaderRow>
            <ResultsHeader>Type</ResultsHeader>
            <ResultsHeader>Description</ResultsHeader>
            <ResultsHeader>Subject</ResultsHeader>
            <ResultsHeader>Edit</ResultsHeader>
          </ResultsHeaderRow>

          {emailPage.map(d => (
            <Row
              template={d}
              key={shortid.generate()}
              fetch={fetchEmailTemplates}
            />
          ))}
        </tbody>
      </Table>
      <Pagination
        numRecords={templates.length}
        perPage={perPage}
        currentPage={currentPage}
        onPageClick={handlePageClick}
        handlePerPageChange={handlePerPageChange}
        hidePerPage={false}
      />
    </>
  );
};

const mapStateToProps = state => ({
  templates: state.email.templates,
  isFetching: state.email.isFetching,
});

const EmailTemplates = connect(
  mapStateToProps,
  { fetchEmailTemplates }
)(EmailTemplatesBase);

export default EmailTemplates;
